import React from "react";
import PropTypes from "prop-types";

import { H1, P } from "orcs-design-system";
import { copywriting } from "./ErrorPage.config";
import ErrorPageWrapper from "./ErrorPageWrapper";
import SupportErrorDetails from "./SupportErrorDetails";

const GenericError = ({
  clientInfo,
  supportErrorDetails,
  showHeader,
  showContainer,
}) => {
  return (
    <ErrorPageWrapper
      clientInfo={clientInfo}
      showHeader={showHeader}
      showContainer={showContainer}
    >
      <H1>{copywriting.genericErrorHeading}</H1>
      <P>{copywriting.genericErrorDetail}</P>
      <SupportErrorDetails details={supportErrorDetails} />
    </ErrorPageWrapper>
  );
};

GenericError.propTypes = {
  clientInfo: PropTypes.string,
  supportErrorDetails: PropTypes.string,
  showHeader: PropTypes.bool,
  showContainer: PropTypes.bool,
};

export default GenericError;
